export interface SAMLEntity {
  provider_id?: string;
  display_name: string;
  idp_entity_id: string;
  rp_entity_id: string;
  sso_url: string;
  x509_certificates: string[];
  idp_type?: string;
}

export interface SamlExistError {
  error_title: string;
  error_detail: string;
  request_id: string;
}

export enum IDPTypes {
  Okta = 'okta',
  OneLogin = 'onelogin',
  AzureAD = 'azuread',
  JumpCloud = 'jumpcloud'
}
